import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=2e6b8d1c&scoped=true&"
import script from "./InfoPopup.vue?vue&type=script&lang=js&"
export * from "./InfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=2e6b8d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b8d1c",
  null
  
)

export default component.exports